import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import api from 'src/axios';
import { getForecastSessionsQueryKey } from 'src/keys';

export type SessionSummary = {
  id: string;
  name: string;
  status: string;
  created_at: string;
  total_products: number;
  validated_number: number;
};

type ForecastSessionsResponse = {
  items: SessionSummary[];
};

export async function getForecastSessions(
  status = 'open',
): Promise<SessionSummary[]> {
  const params = new URLSearchParams({ status });
  const { data } = await api.get<ForecastSessionsResponse>(
    `/sales-forecasting-sessions?${params.toString()}`,
  );

  return data.items;
}

export function useForecastSessionsQuery(
  status = 'open',
): UseQueryResult<SessionSummary[], Error> {
  return useQuery({
    queryKey: getForecastSessionsQueryKey(status),
    queryFn: async () => getForecastSessions(status),
  });
}
